import { useRecoilState } from 'recoil'
import deleteAutoAssignModalAtom from '@/recoil/deleteAutoAssignModal'
import message from '@/libs/message'
import { deleteAutoAssign } from '@/services/healthClaim/useDeleteHealthClaimAutoAssignment'
import { useHealthClaimAutoAssignment } from '@/services/healthClaim/useHealthClaimAutoAssignment'

export default function DeleteAutoAssignModalHook() {
  const [deleteAutoAssignModal, setDeleteAutoAssignModal] =
    useRecoilState(deleteAutoAssignModalAtom)
  const queryListAutoAssignee = useHealthClaimAutoAssignment({
    search: '',
    page: 1,
    limit: 10,
    enabled: true,
  })

  const refethAutoAssignTable = () => {
    queryListAutoAssignee.refetch()
  }

  const handleSetDeleteAutoAssignModal = () => {
    if (deleteAutoAssignModal.backofficeUserId)
      deleteAutoAssign(deleteAutoAssignModal.backofficeUserId)
        .finally(() => {
          setDeleteAutoAssignModal({
            backofficeUserId: undefined,
            open: false,
            fullname: undefined,
          })
          message.success({ content: 'ลบสมาชิกสำเร็จ', duration: 10 })
          refethAutoAssignTable()
        })
        .catch(() => {
          message.error({
            content: `เกิดข้อผิดพลาด`,
            duration: 10,
          })
        })
  }

  const onCancelModal = () => {
    setDeleteAutoAssignModal({ backofficeUserId: undefined, open: false, fullname: undefined })
  }

  return {
    deleteAutoAssignModal,
    handleSetDeleteAutoAssignModal,
    onCancelModal,
    fullname: deleteAutoAssignModal.fullname,
  }
}
